module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/icon-play-c7447192bb2a1fdf565e0d8ce23eeae3.svg";